<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-12-01 16:41:20
 * @LastEditors: xgx
 * @LastEditTime: 2022-12-11 18:37:14
-->
<template>
  <el-dialog
    title="选择微博"
    :visible.sync="isShowWeiBo"
    width="1000px"
    class="column-box"
    top="12%"
   @close="close"
  >
    <div class="log-box">
      <div
        @click="changeType(1)"
        :style="{
          color: type == 1 ? '#1890FF' : '',
          borderBottom: type == 1 ? 'none' : '',
        }"
        class="log"
      >
        我授权的微博
      </div>
      <div
        @click="changeType(2)"
        :style="{
          color: type == 2 ? '#1890FF' : '',
          borderBottom: type == 2 ? 'none' : '',
        }"
        class="log"
      >
        其他人授权的微博
      </div>
    </div>
    <div class="dir"></div>
    <div class="searchTwo">
      <a-input
        v-model="questionDescription"
        placeholder="微博名称"
        style="width: 173px"
      />
      <a-button style="margin-left: 12px" type="primary" @click="getAnswerPage"
        >查询</a-button
      >
    </div>
    <coententTable
      :columns="columnsTwo"
      :data-source="dataSourceTwo"
      :pagination="false"
      :scroll="{ y: 400 }"
      @selectedRowKeys="selectedRowKeys"
      :rowKeys="rowKeys"
      :isSelectRow="true"
      :customSlot="customSlot"
      :loading="loading"
      class="change-table"
    >
      <template v-slot:state="scopeVal">
        <span
          :class="[
            scopeVal.scope.state == 1
              ? 'Status1'
              : scopeVal.scope.state == 2
              ? 'Status2'
              : '',
          ]"
          >{{
            scopeVal.scope.state == 0
              ? "未授权"
              : scopeVal.scope.state == 1
              ? "有效授权"
              : "已取消授权"
          }}</span
        >
      </template>
    </coententTable>
    <div class="footer-page">
      <a-pagination
        :pageSize="size"
        :current="current"
        :total="total"
        @change="onChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="tihuan">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import { selectListPageWeiBo } from "./manuscripts";
export default {
  data() {
    return {
      questionDescription: "",
      size: 10,
      current: 1,
      total: 0,
      rowKeys: [],
      selectedRows:[],
      type: 1,
      loading: false,
      columnsTwo: [
        {
          title: "微博账号",
          dataIndex: "screenName",
          ellipsis: true,
        },
        {
          title: "状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
        },
        {
          title: "授权人",
          dataIndex: "createName",
        },
        {
          title: "授权时间",
          dataIndex: "grantTime",
        },
        {
          title: "刷新授权时间",
          dataIndex: "refreshTime",
        },
      ],
      dataSourceTwo: [],
      customSlot: [
        {
          name: "state",
          customRender: "state",
        },
      ],
      selectData:[],
    };
  },
  components: {
    coententTable,
  },
  props: ["isShowWeiBo",'newSelectData'],
  mounted() {
    this.getList();
    let array = [];
    for (let index = 0; index < this.newSelectData.length; index++) {
       array.push(this.newSelectData[index].id)
    }
    this.rowKeys = array;
    this.selectedRowKeys(array,this.newSelectData);
  },
  methods: {
    selectedRowKeys(keys,selectedRows) {
      let array = [];
      this.rowKeys = keys;
      console.log(this.rowKeys);
      for (let index = 0; index < selectedRows.length; index++) {
        this.selectedRows.push(selectedRows[index]);
        
      }
      for (let index = 0; index < this.selectedRows.length; index++) {
          if(this.selectedRows[index]){
              if(this.rowKeys.indexOf(this.selectedRows[index].id) != -1){
              array.push(this.selectedRows[index])
            }
          }
      }
      this.selectData = array;
      console.log(array,'这里有几条')
    },
    close() {
      this.$emit("selectCloseWeiBo");
    },
    tihuan() {
      let data = this.objHeavy(this.selectData)
      console.log(this.selectData,'ssssss')
      this.$emit('newMediaWeiBo',data)
      this.close();
    },
    objHeavy(arr){
        let arr1 = []; //存id
        let newArr = []; //存新数组
        for(let i in arr){
          if(arr1.indexOf(arr[i].id) == -1){
            arr1.push(arr[i].id);
            newArr.push(arr[i]);
          }
        }
        return newArr;
      },
    onShowSizeChange() {},
    handleSizeChange() {},
    getAnswerPage() {
      this.getList();
    },
    onChange(page) {
      this.current = page;
      this.getList();
    },
    changeType(type) {
      this.type = type;
      this.getList();
    },
    getList() {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      let userId = this.type == 1 ? userInfo.id : "";
      this.loading = true;
      selectListPageWeiBo({
        current: this.current,
        size: this.size,
        userId,
        name: this.questionDescription,
        siteId: sessionStorage.getItem("siteId"),
      }).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.dataSourceTwo = JSON.parse(JSON.stringify(res.data.records));
          this.total = res.data.total;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.searchTwo {
  display: flex;
  margin-top: 20px;
}
.footer-page {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  margin-bottom: 24px;
}
.log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  .log {
    padding: 10px 20px;
    border-top: solid 1px #dcdfe6;
    border-left: solid 1px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 1px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 1px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 306px;
  /* margin-right: 24px; */
  margin-top: -1px;
}
.Status1 {
  color: #67c23a;
}
.Status2 {
  color: #f56c6c;
}
/deep/ .table {
  margin: 20px 0px;
}
</style>